const ImageIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 22V8C24 6.9 23.1 6 22 6H8C6.9 6 6 6.9 6 8V22C6 23.1 6.9 24 8 24H22C23.1 24 24 23.1 24 22ZM11.9 16.98L14 19.51L17.1 15.52C17.3 15.26 17.7 15.26 17.9 15.53L21.41 20.21C21.66 20.54 21.42 21.01 21.01 21.01H9.02C8.6 21.01 8.37 20.53 8.63 20.2L11.12 17C11.31 16.74 11.69 16.73 11.9 16.98Z"
        fill="#C3CAD9"
      />
    </svg>
  );
};

export default ImageIcon;
